export default {
    SET_SELECT_SYNDICATOR(state,Syndicator){
        state.selectSyndicator = Syndicator
    },
    SET_RESULT(state,result){
        state.Result = result
    },
    SET_EDIT_SYNDICATOR(state,editSyndicator){
        state.editRepresentative = editSyndicator
    },
}
